import { render, staticRenderFns } from "./UsageCost.vue?vue&type=template&id=2b47a35e"
import script from "./UsageCost.vue?vue&type=script&lang=js"
export * from "./UsageCost.vue?vue&type=script&lang=js"
import style0 from "./UsageCost.vue?vue&type=style&index=0&id=2b47a35e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports